const actionTypes = require('constants/actionTypes');
const apiURLBuilder = require('core/apiURLBuilder');
const { Promise } = require('es6-promise');
const { APIGet } = require('utilities/APIRequestHelper');
const { getProductFileAction } = require('actions/brokerGetProductFile');

function requestProductFileSuccess(response) {
    return {
        type: actionTypes.BROKER_GET_PRODUCT_FILE_SUCCESS,
        payload: {
            data: response
        }
    };
}

function requestProductFileFailure(response) {
    return {
        type: actionTypes.BROKER_GET_PRODUCT_FILE_FAILURE,
        payload: {
            data: response
        }
    };
}

function requestETFsProductSuccess(response) {
    return {
        type: actionTypes.BROKER_ETF_PRODUCT_SUCCESS,
        payload: {
            data: response
        }
    };
}

const requestETFsProductFetching = () => {
    return {
        type: actionTypes.BROKER_ETF_PRODUCT_FETCHING
    };
};

const requestETFsCatalogueFetching = () => {
    return {
        type: actionTypes.BROKER_ETF_CATALOGUE_FETCHING
    };
};

const requestETFsCatalogueSuccess = (data) => {
    return {
        type: actionTypes.BROKER_ETF_CATALOGUE_SUCCESS,
        payload: data,
    };
};

const requestETFsCatalogueFailure = () => {
    return {
        type: actionTypes.BROKER_ETF_CATALOGUE_FAILURE
    };
};

function requestETFsProductFailure(response) {
    return {
        type: actionTypes.BROKER_ETF_PRODUCT_FAILURE,
        payload: {
            data: response
        }
    };
}

function requestETFsDocumentationSuccess(response) {
    return {
        type: actionTypes.BROKER_ETF_PRODUCT_DOCUMENTATION_SUCCESS,
        payload: {
            data: response
        }
    };
}

function requestETFsDocumentationFetching() {
    return {
        type: actionTypes.BROKER_ETF_PRODUCT_DOCUMENTATION_FETCHING
    };
}

function requestETFsDocumentationFailure() {
    return {
        type: actionTypes.BROKER_ETF_PRODUCT_DOCUMENTATION_FAILURE,
    };
}


function requestETFsProductAnotherSuccess(response) {
    return {
        type: actionTypes.BROKER_ETF_PRODUCT_ANOTHER_SUCCESS,
        payload: {
            data: response
        }
    };
}

const getETFsCatalogueDetails = (isin) => (dispatch) => {
    const requestData = {
        query: {
            text: isin,
            pageSize: 5,
            pageSizeGroup: 10,
            pageNumber: 1,
        }
    };

    dispatch(requestETFsCatalogueFetching());

    return APIGet(dispatch, apiURLBuilder.getURL('catalogueBrokerAdvancedSearch'), requestData)
        .then((response) => dispatch(requestETFsCatalogueSuccess(response)))
        .catch(() => dispatch(requestETFsCatalogueFailure()))
}

function getETFsProductByIsin(dispatch, isin) {
    const requestData = {
        query: {
            viewId: 'full',
            idType: 'ISINMKT',
            responseViewFormat: 'json'
        }
    };

    dispatch(requestETFsProductFetching());

    APIGet(dispatch, apiURLBuilder.getURL('etfsProduct',  {isin} ), requestData).then(
        function(response) {
            dispatch(requestETFsProductSuccess(response));
        },
        function(response) {
            dispatch(requestETFsProductFailure(response));
        }
    );
}

function getETFsDocumentsAction(dispatch, isin) {
    const requestData = {
        query: {
            productType: 'ETF',
            documentType: 'pdf'
        }
    }

    dispatch(requestETFsDocumentationFetching());

    APIGet(dispatch, apiURLBuilder.getURL('etfsDocuments', {isin} ), requestData).then(
        function(response) {
            dispatch(requestETFsDocumentationSuccess(response));
        },
        function() {
            dispatch(requestETFsDocumentationFailure());
        }
    );
}

function getETFsProductAction(dispatch, exchangeId, spcSymbol, screen) {
    return new Promise(function() {
        const requestData = {
            query: {
                pageNum: 1,
                pageSize: 1,
                exchangeId,
                spcSymbol,
                screen
            }
        };

        APIGet(dispatch, apiURLBuilder.getURL('productFile'), requestData)
            .then(
                function(response) {
                    dispatch(requestProductFileSuccess(response));
                    return response;
                },
                function(response) {
                    dispatch(requestProductFileFailure(response));
                }
            )
            .then(function(response) {
                const isin = response[0].instrumentId.trim() + response[0].currencyCode + "EX$$$$" + response[0].miccode.trim();

                getETFsProductByIsin(dispatch, isin);

                return response;
            })
            .then(function() {
                const isin = exchangeId;

                const requestData = {
                    query: {
                        securityDataPoints:
                            'SecId|ISIN|Name|CustomBuyFee|CustomSellFee|CustodianFee|DistributionFee|CustomMinimumAdditionalPurchaseAmount|CustomMinimumAdditionalPurchaseAmountUnit|CustomMinimumPurchaseAmount|CustomMinimumPurchaseAmountUnit',
                        pageSize: 5000,
                        outputType: 'json',
                        languageId: 'es-ES',
                        currencyId: 'EUR',
                        universeIds: 'FOEUR$$ALL_2118',
                        filters: `secID:EQ:${isin}`
                    }
                };

                APIGet(
                    dispatch,
                    apiURLBuilder.getURL('etfsProductAnotherService'),
                    requestData
                ).then(
                    function(response) {
                        dispatch(requestETFsProductAnotherSuccess(response.rows[0]));
                    },
                    function(response) {
                        dispatch(requestProductFileFailure(response));
                    }
                );
            });
    });
}

const getETFsProduct = (exchangeId, spcSymbol, screen) => (dispatch) => (getETFsProductAction(dispatch, exchangeId, spcSymbol, screen));

const getETFsRatingRiskTab = (isin) => (dispatch) => (getETFsProductByIsin(dispatch, isin))

const getProductFile = (isin, iso, screen) => (dispatch) => (getProductFileAction(dispatch, isin, iso, screen, 'etfFile'));

const getETFsDocuments = (isin) => (dispatch) => (getETFsDocumentsAction(dispatch, isin))

module.exports = {
    getETFsDocuments,
    getETFsProduct,
    getETFsRatingRiskTab,
    getETFsProductByIsin,
    getProductFile,
    getETFsCatalogueDetails
}
